import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Badge, Page, PageHeader } from "../../../components/ui";
import { mustChangePassword } from "../../../services/auth";
import ChangePasswordCard from "./ChangePasswordCard";
import "./profile.css";

/** Role key as translated in the header ("super admin" -> "Super Admin"). */
const titleCase = (role) => role.replace(/\b\w/g, (c) => c.toUpperCase());

/** Profile of the logged-in admin (from the cached session). */
const UserProfile = () => {
  const { t } = useTranslation();
  const [temporary, setTemporary] = useState(mustChangePassword());
  const session = JSON.parse(localStorage.getItem("session")) || {};
  const roles = Array.isArray(session.role)
    ? session.role
    : [session.role].filter(Boolean);

  return (
    <Page>
      <PageHeader title={t("My profile")} />
      <section className="ui-card profile-card">
        <span className="profile-avatar" aria-hidden="true">
          {(session.name || "?").charAt(0).toUpperCase()}
        </span>
        <div className="profile-body">
          <h2 className="profile-name">{session.name || "—"}</h2>
          {session.email && <p className="profile-email">{session.email}</p>}
          <div className="profile-roles">
            {roles.map((role) => (
              <Badge key={role} color="blue">
                {t(titleCase(role))}
              </Badge>
            ))}
          </div>
        </div>
      </section>
      <ChangePasswordCard temporary={temporary} onChanged={() => setTemporary(false)} />
    </Page>
  );
};

export default UserProfile;
